<template>
<g>
  <complexagon
    v-for="(hexagon, index) in piles"
    :key="index + 1"
    :id="index"
    :groupId="hexagon.group"
    :value="hexagon.v"
    :x="horizontal ? 5 * scale + getY(index) : getX(index)"
    :y="horizontal ? getX(index) : getY(index)"
    :angle="horizontal ? 30 : 0"
    :gradient="horizontal ? {x1: 0, x2: .5, y1: 0, y2: 1} : {x1: 0, x2: 1, y1: 0, y2: 0}"
    :gradientSpread="gradientSpread"
    :scale="scale"
    :curve="curve"
    :onColor="hexagon.on"
    :offColor="hexagon.off"
    @hc-hover="onHover"
    class="hc-hexastack-complexagon"
  />
</g>
</template>

<script>
import Complexagon from './combo/Complexagon'
export default {
  name: 'Hexastack',
  components: {
    Complexagon
  },
  props: {
    data: {
      type: Array,
      default () {return []}
    },
    curve: {
      type: Number,
      default: 1
    },
    colors: {
      type: Array,
      default () { return ['#f67055']}
    },
    offColor: {
      type: String,
      default: '#757575'
    },
    size: {
      type: Number,
      default: 100
    },
    columns: {
      type: Number,
      default: 5
    },
    rows: {
      type: Number,
      default: 20
    },
    horizontal: {
      type: Boolean,
      default: false
    },
    direction: {
      type: String,
      default: 'ltr'
    },
    onHover: {
      type: Function,
      default () {}
    },
    scale: {
      type: Number,
      default: 1
    },
    gradientSpread: {
      type: Number,
      default: .5
    }
  },
  methods: {
    getValue (index) {
      const rest = this.stacked[this.stacked.length - 1] - index
      if (rest >= 1) {
        return 1
      }
      if (rest <= 0) {
        return 0
      }
      return Math.round(rest)
    },
    getX (index) {
      return this.offsetX + ((index % this.columns) * 30 + ((Math.floor(index / this.columns) % 2) ? 15 : 0)) * this.scale + (1 - this.scale) * 2.5
    },
    getY (index) {
      return Math.floor(index / this.columns) * 26 * this.scale
    }
  },
  computed: {
    offsetX () {
      return this.direction === 'rtl' ? 0 : 170 * this.scale
    },
    slices () {
      let slices = []
      let previous = 0
      for (let i = 0; i < this.data.length; i++) {
        if (i && (this.data[i] % 1)) {
          previous = this.data[i] - (1 - ((previous - 1e-15) % 1))
        } else {
          previous = this.data[i]
        }
        slices[i] = previous
      }
      return slices
    },
    piles () {
      let piles = []
      for (let i = 0; i < this.slices.length; i++) {
        piles = piles.concat(Array.apply(null, {length: Math.floor(this.slices[i])})
          .map(() => { return {v: 1, on: this.colors[i], off: this.colors[i + 1] || this.offColor, group: i}}))
        if (this.slices[i] % 1) {
          piles.push({v: this.slices[i] % 1, on: this.colors[i], off: this.colors[i + 1] || this.offColor, group: i})
        }
        if (piles.length >= this.size) {
          break
        }
      }
      if (piles.length < this.size) {
        piles = piles.concat(Array.apply(null, {length: this.size - piles.length}).map(() => {
          return {v: 0, on: this.offColor, off: this.offColor, group: -1}
        }))
      }
      return piles.slice(0, this.size)
    }
  }
}
</script>

<style>

</style>
